import React from 'react';
import { Fab } from '../Fab';
import TelephoneIcon from '../Icons/TelephoneIcon';
import MinimizeIcon from '../Icons/MinimizeIcon';
import { useTelephonyContext } from '../../../contexts/TelephonyContext';
import { Box } from '@coolblue-development/freddy';

const TelephonyWidgetButton = (): JSX.Element => {
  const { isTelephonyWidgetOpen, setIsTelephonyWidgetOpen } = useTelephonyContext();

  const handleToggle = (): void => {
    setIsTelephonyWidgetOpen(prevIsTelephonyWidgetOpen => !prevIsTelephonyWidgetOpen);
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Fab
          sx={{ background: '#FFF', border: '1px solid #DDD', ':hover': { background: '#F0F0F0' } }}
          onClick={handleToggle}
        >
          {isTelephonyWidgetOpen ? (
            <MinimizeIcon data-testid="minimize-icon" />
          ) : (
            <TelephoneIcon data-testid="telephone-icon" />
          )}
        </Fab>
      </Box>
    </>
  );
};

export default TelephonyWidgetButton;
